import { Inject, Injectable, PLATFORM_ID, signal } from '@angular/core';
import { serverTimestamp, setDoc, doc, Firestore, getDoc, collection, query, getDocs, where, limit } from '@angular/fire/firestore';
import { getFunctions, httpsCallable } from '@angular/fire/functions';
import { getApp } from '@firebase/app';
import { CookieService } from 'ngx-cookie-service';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
// import { DashboardMessageService } from 'src/app/services/dashboard-message.service';
// import { UploadQuestionComponent } from '../workbench/editor-main/upload-question/upload-question.component';

import { HttpClient } from '@angular/common/http';
import { DashboardMessageService } from './dashboard-message.service';
import { environment } from '../../environments/environment';
import { single } from 'rxjs';
import { isPlatformBrowser } from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class HelperService {
  topSearch: any = []
  category: any = [{
    categoryDescription: "Business",
    categoryId: 23,
    fieldId: 'business',
  },
  {
    categoryDescription: "Entertainment",
    categoryId: 26,
    fieldId: 'entertainment',
  },
  {
    categoryDescription: "Food",
    categoryId: 22,
    fieldId: 'food',
  },
  {
    categoryDescription: "Health & Fitness",
    categoryId: 21,
    fieldId: "health-fitness",
  },
  {
    categoryDescription: "Incredible India",
    categoryId: 29,
    fieldId: "incredible-india",
  },
  {
    categoryDescription: "Language",
    categoryId: 11,
    fieldId: "language",
  },
  {
    categoryDescription: "News",
    categoryId: 27,
    fieldId: "news",
  },
  {
    categoryDescription: "Sports",
    categoryId: 25,
    fieldId: "sports",
  },
  {
    categoryDescription: "Technology",
    categoryId: 12,
    fieldId: "technology",
  },
  {
    categoryDescription: "World Travel",
    categoryId: 28,
    fieldId: "world-travel",
  }, {
    categoryDescription: "General",
    categoryId: 30,
    fieldId: "general",
  }, {
    categoryDescription: "Luxury",
    categoryId: 32,
    fieldId: "luxury",
  }, {
    categoryDescription: "Electric",
    categoryId: 31,
    fieldId: "electric",
  }, {
    categoryDescription: "Others",
    categoryId: 33,
    fieldId: "others",
  }
  ]
  isBrowser=true
  // slientAudio= new Audio('assets/asd.mp3')
  private audio: HTMLAudioElement | null = null;
  private isStarted = false;
savedTextForEmailDynamic=''
  constructor(private firestore: Firestore,
    @Inject(PLATFORM_ID) platformId: Object,
    public cookieService: CookieService,
    private _snackBar: MatSnackBar,
    public dialog: MatDialog,
    private messageService: DashboardMessageService,
    // private http: HttpClient
  ) { 
    this.isBrowser = isPlatformBrowser(platformId);


  }

  startKeepAlive(): void {
    if (this.isStarted || typeof Audio === 'undefined') return;

    this.audio = new Audio('assets/asd.mp3');
    this.audio.loop = true;
    this.audio.volume = 0;

    this.audio
      .play()
      .then(() => {
        // console.log('[AudioKeepAlive] Silent audio started');
        this.isStarted = true;
      })
      .catch(err => {
        console.error('[AudioKeepAlive] Failed to start silent audio:', err);
      });
  }

  stopKeepAlive(): void {
    if (this.audio) {
      this.audio.pause();
      this.audio = null;
      this.isStarted = false;
      // console.log('[AudioKeepAlive] Silent audio stopped');
    }
  }
  public setTopSearches(v: any) {
    this.topSearch = v;
  }

  public getTopSearches() {
    return this.topSearch;
  }


  public setSavedTextEmail(str: any) {
    this.savedTextForEmailDynamic = str;
  }

  public getSavedTextEmail() {
    return this.savedTextForEmailDynamic;
  }

  getCurrentISTTime() {
    return new Promise(async (resolve, reject) => {
       try {
         let res:any
         if(environment.curiosity=='https://gospring.ai'){
           res= await fetch("https://us-central1-quiz42.cloudfunctions.net/getServerCurrentTime")
         }else{
           res= await fetch("https://us-central1-curiosity-road.cloudfunctions.net/getServerCurrentTime")
         }
   
         const json=await res.json();
         if(json)resolve(json)
       } catch (error) {
         console.error("Error occurred while fetching IST time:", error);
         reject(null) ;
       }
     })
   }

  uuidv4() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
    });
  }
  uuidv8() {
    return 'xxxyyxxx'.replace(/[xy]/g, function (c) {
      var r = Math.random() * 17 | 0, v = c == 'x' ? r : (r & 0x3);
      return v.toString(17);
    });
  }
  uuidv6() {
    return 'xyxyxy'.replace(/[xy]/g, function (c) {
      var r = Math.random() * 10 | 0; 
      return r.toString();
  });
  }

  getLocationAndDeviceInfo() {
    return new Promise((resolve, reject) => {
      try {
        const functions = getFunctions(getApp())
        let f = httpsCallable(functions, 'getLocationNDeviceInfo')
        resolve(f({}));
      } catch (error) {
        reject(error)
      }
    })
  }

  closeTabAfter(delay: number): void {
    if(this.isBrowser){
      setTimeout(() => {
        window.close();
      }, delay);

    }
  }

  getLeaderBoard(request: any) {
    return new Promise((resolve, reject) => {
      try {
        if (request) {
          const functions = getFunctions(getApp());
          var getLeaderboardList = httpsCallable(functions, 'getLeaderboardList');
          getLeaderboardList(request).then((result: any) => {
            resolve(result);
          }).catch((err: any) => {
            console.log("getLeaderboardList request err : ", err)
            reject(err)
          });
        } else {
          console.log("request data not found")
        }
      } catch (error: any) {
        console.log("try&catch error while calling method : ", error)
        reject(error)
      }
    });
  }

  updateAnswerStats(answerStats: any) {
    let docRef = doc(this.firestore, 'answer_stats', answerStats.instance + "_" + answerStats.question)
    answerStats['updatedOn'] = serverTimestamp();
    setDoc(docRef, answerStats, { merge: true });
  }

  getShortUrl(project: any) {
    return new Promise((resolve, reject) => {
      let ref: any = null;
      let urlRef = collection(this.firestore, 'urls')
      if (project.quizId) {
        ref = query(urlRef, where('quizId', '==', project.quizId), limit(1));
      } else if (project.pollId) {
        ref = query(urlRef, where('pollId', '==', project.pollId), limit(1));
      } else if (project.campaignId) {
        ref = query(urlRef, where('campaignId', '==', project.campaignId), limit(1));
      } else {
        reject(null)
        return;
      }
      let urls: any = [];
      getDocs(ref).then((docs) => {
        docs.forEach((doc) => {
          let urlData = doc.data()
          urls.push(urlData)
        });
        if (urls[0] && urls[0].springly)
          resolve(urls[0].springly)
        else if (urls[0] && urls[0].longUrl)
          resolve(urls[0].longUrl)
        else
          reject(null)
      })
        .catch((err) => {
          reject(null);
        });
    })
  }
  getShortUrlObj(project: any) {
    return new Promise((resolve, reject) => {
      let ref: any = null;
      let urlRef = collection(this.firestore, 'urls')
      if (project.quizId) {
        ref = query(urlRef, where('quizId', '==', project.quizId), limit(1));
      } else if (project.pollId) {
        ref = query(urlRef, where('pollId', '==', project.pollId), limit(1));
      } else {
        reject(null)
        return;
      }
      let urls: any = [];
      getDocs(ref).then((docs) => {
        docs.forEach((doc) => {
          let urlData = doc.data()
          urls.push(urlData)
        });
        resolve(urls[0])
      })
        .catch((err) => {
          reject(null);
        });
    })
  }

  setUrlObj(urlId: any, data: any) {
    return new Promise((resolve, reject) => {
      let queryRef: any = doc(this.firestore, 'urls', urlId)
      setDoc(queryRef, data, { merge: true }).then((result) => {
        resolve(result);
      }).catch((err) => {
        reject(err);
      });
    });
  }

  async logEvent(message: string, data: any) {
    // var result = await firebase.analytics.isSupported();
    // if(result){
    //   this.analytics.logEvent(message,data);
    // }
  }

  getQuizStats(quizId: string) {
    return new Promise((resolve, reject) => {
      let ref = doc(this.firestore, 'quiz_stats', quizId)
      getDoc(ref).then(result => {
        resolve(result.data())
      }).catch(err => {
        reject(err)
      })
    })
  }
  getCategory() {
    return new Promise(async (resolve, reject) => {
      let category: any = []
      let refCateogry = collection(this.firestore, 'category')
      await getDocs(refCateogry).then(snapshot => {
        snapshot.forEach(result => {
          category.push(result.data())
        })
        resolve(category)
      }).catch(err => {
        console.warn(err)
        reject(err)
      })
    })
  }

  getCategoryStats(accountId: any) {
    return new Promise(async (resolve, reject) => {
      let refCateogryStatus = doc(this.firestore, 'category_stats', accountId)
      await getDoc(refCateogryStatus).then(snapshot => {
        resolve(snapshot.data())
      }).catch(err => {
        console.warn(err)
        reject(err)
      })
    })
  }

  //getting category collection data
  getGategories() {
    let category: any = [];
    return new Promise((resolve, reject) => {
      let queryRef = query(collection(this.firestore, "category"));
      getDocs(queryRef)
        .then((docs) => {
          docs.forEach((doc) => {
            let categoryData = doc.data();
            category.push(categoryData);
          });
          resolve(category);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  getTopSearch() {
    return new Promise((resolve, reject) => {
      //Call the function that creates the quiz from the template
      const functions = getFunctions(getApp());
      var getTopSearch = httpsCallable(functions, 'getTopSearch');

      getTopSearch({}).then((result) => {
        resolve(result);
      }).catch((err) => {
        reject(err);
      });
    });
  }

  fitWidgetsOnChange() {
if(this.isBrowser)
    window.addEventListener('resize', this.renderQuizsPosition);
  }
  fitGameWidgetsOnChange() {
    if(this.isBrowser)
    window.addEventListener('resize', this.renderGamesPosition);
  }

  removefitWidgetsOnChange() {
    if(this.isBrowser)
    window.removeEventListener('resize', this.renderQuizsPosition);
  }
  removefitGameWidgetsOnChange() {
    if(this.isBrowser)
    window.removeEventListener('resize', this.renderGamesPosition);
  }

  renderQuizsPosition() {
    let widgetWidth = 226;
    let widgetHeight = 330;
    let items = document.getElementsByClassName('cr-quiz')
    let divWidth: any = document.getElementsByClassName('container')[0]?.clientWidth;
    let possibleDivs: any = (divWidth - 50) / widgetWidth;
    possibleDivs = parseInt(possibleDivs);
    if (possibleDivs >= 3) {
      for (let idx = 0; idx < items.length; idx++) {
        let item: any = items[idx];
        let width: any = ((divWidth - 60) / possibleDivs) - 10;
        let height = widgetHeight + ((width - widgetWidth) * 1.2);
        item.style.height = height + 'px';
        item.style.width = width + 'px';
      }
    } else {
      for (let idx = 0; idx < items.length; idx++) {
        let item: any = items[idx];
        item.style.height = widgetHeight + 'px';
        item.style.width = widgetWidth + 'px';
      }
    }
  }
  renderGamesPosition() {
    let widgetWidth = 230;
    let widgetHeight = 303;
    let items = document.getElementsByClassName('game')
    let divWidth: any = document.getElementsByClassName('games-container')[0].clientWidth;
    let possibleDivs: any = (divWidth - 50) / widgetWidth;
    possibleDivs = parseInt(possibleDivs);
    if (possibleDivs >= 3) {
      for (let idx = 0; idx < items.length; idx++) {
        let item: any = items[idx];
        let width: any = ((divWidth - 8) / possibleDivs) - 20;
        let height = widgetHeight + ((width - widgetWidth) * 0.5);
        item.style.height = height + 'px';
        item.style.width = width + 'px';
      }
    } else {
      for (let idx = 0; idx < items.length; idx++) {
        let item: any = items[idx];
        item.style.height = widgetHeight + 'px';
        item.style.width = widgetWidth + 'px';
      }
    }
  }
  getChainDetails(chainId: any) {
    return new Promise((resolve, reject) => {
      const ref = doc(this.firestore, 'quizChain', chainId)
      getDoc(ref).then(doc => {
        if (doc.data()) {
          let chainDetails: any = null;
          chainDetails = doc.data();
          chainDetails.id = doc.id;
          resolve(chainDetails)
        } else {
          resolve(null)
        }
      }).catch(err => {
        console.log(err)
        resolve(null)
      });
    })
  }
  getpollChainDetails(chainId: any) {
    return new Promise((resolve, reject) => {
      const ref = doc(this.firestore, 'pollChain', chainId)
      getDoc(ref).then(doc => {
        if (doc.data()) {
          let chainDetails: any = null;
          chainDetails = doc.data();
          chainDetails.id = doc.id;
          resolve(chainDetails)
        } else {
          resolve(null)
        }
      }).catch(err => {
        console.log(err)
        resolve(null)
      });
    })
  }
  checkCookieIsSupported(data: any, cookieString: any) {
    this.cookieService.set(data, cookieString, 60, '/', undefined, false, "None");
    if (this.cookieService.check(data))
      return true;
    else
      return false;
  }

  getEmbedUrlForQuiz(accountDetails: any, quizDetails: any) {
    if (accountDetails && accountDetails.microEmbed?.baseUrl) {
      let { url } = this.getEmbedChildUrlForQuiz(accountDetails, quizDetails);
      url = accountDetails.microEmbed?.baseUrl + '/' + url;
      return url;
    } else {
      return null;
    }
  }

  getEmbedChildUrlForQuiz(accountDetails: any, quizDetails: any) {
    if (accountDetails && accountDetails.microEmbed) {
      // Set refCategoryId 30 as general category if category is not available.
      let categoryId = quizDetails?.refCategoryId || 30;
      let categories = this.category;
      let selectedCategory = null;
      let midUrl = accountDetails.microEmbed?.childPath;
      let fileName = "";
      let url = "";
      if (categoryId) {
        selectedCategory = categories.find((c: any) => c.categoryId == categoryId)
        // If given category is not listed then also use that as general category
        if (!selectedCategory)
          selectedCategory = categories.find((c: any) => c.categoryId == 30)
        if (selectedCategory && selectedCategory.categoryDescription)
          midUrl = `${midUrl}/${selectedCategory.fieldId}`;
      }
      if (quizDetails?.quizName) {
        fileName = `${this.getFormattedNamesForMicroSite(quizDetails?.quizName)}.html`
      }
      if (midUrl) {
        url = `${midUrl}/${fileName}`;
      } else {
        url = `${fileName}`;
      }
      return { midUrl, fileName, url };
    } else {
      return { midUrl: null, fileName: null, url: null };
    }
  }

  getMicroCategoryUrl(accountDetails: any, category: any) {
    if (accountDetails && accountDetails.microEmbed) {
      let categoryId = category?.fieldId;
      let url = accountDetails.microEmbed?.childPath;
      url = `${url}/${categoryId}`;
      return { url };
    } else {
      return { url: null };
    }
  }
  getFormattedNamesForMicroSite(name: String) {
    if (!name) return;
    let rname = name.toLocaleLowerCase();
    rname = rname.replace(/[^a-zA-Z0-9 ]/g, "").replace(/\s/g, '-');
    return rname;
  }

  getPageUrlForMicroSite(quizDetails: any, pageIdx: any) {
    let url;
    let categoryId = quizDetails?.refCategoryId || 30;
    let categories = this.category;
    let selectedCategory = null;
    if (categoryId) {
      selectedCategory = categories.find((c: any) => c.categoryId == categoryId)
      // If given category is not listed then also use that as general category
      if (!selectedCategory)
        selectedCategory = categories.find((c: any) => c.categoryId == 30)
    }

    if (quizDetails?.quizName) {
      url = `${selectedCategory.fieldId}/${this.getFormattedNamesForMicroSite(quizDetails?.quizName)}/page${pageIdx}.html`
    }
    return url;
  }

  // ===================upload questions=====================
  uploadQuestions(project: any) {
    // if (project.quizStatus != 'd') {
    //   var message = "New content can be added only if story is in Draft."
    //   this._snackBar.open(message, "", {
    //     duration: 2000,
    //   });
    //   return;
    // }
    // const dialogRef = this.dialog.open(UploadQuestionComponent, {
    //   width: '700px',
    //   maxHeight:'100%',
    //   data: { projectDetails: project }
    // });
    // dialogRef.afterClosed().subscribe(result => {
    //   if (result && result.processed) {
    //     this.messageService.changeMessage("refresh-question-list")
    //   }
    // });
  }

  // =====================download questions======================
  downloadQuestions(project: any, downloadFileType:any=null,playerPerRound_numberOfRounds_numberOfPlayer:any=null) {
    this.messageService.changeMessage("show-loader-on-editor")
    if (project.quizId) {
      var data: any = {
        "contentId": project.refContentId,
        "quizId": project.quizId,
        "quizType": project.quizType,
        "downloadFileType": downloadFileType,
        "playerPerRound_numberOfRounds_numberOfPlayer":playerPerRound_numberOfRounds_numberOfPlayer
      }
    }
    if (project.pollId) {
      var data: any = {
        "contentId": project.refContentId,
        "pollId": project.pollId
      }
    }

    // this.downloadQuizPollQuestion(data).then((result: any) => {
    //   if (downloadFileType && downloadFileType == 'tsv') {
    //     const blob = new Blob([result], { type: 'text/tsv' });
    //     const downloadLink = document.createElement('a');
    //     downloadLink.href = window.URL.createObjectURL(blob);
    //     let name = project.quizName ? project.quizName : project.pollName;
    //     downloadLink.download = name + '_' + Date.now() + ".tsv";
    //     downloadLink.click();
    //   } else {
    //     if (result && result.size) {
    //       let blob = new Blob([result], { type: 'application/ms-excel' });
    //       let link = document.createElement('a');
    //       link.href = window.URL.createObjectURL(blob);
    //       let name = project.quizName ? project.quizName : project.pollName;
    //       link.setAttribute("download", name + '_' + Date.now() + ".xlsx"); // Added Line 
    //       link.click();
    //       // let pwa = window.open(url);
    //       // if (!pwa || pwa.closed || typeof pwa.closed == 'undefined') {
    //       //     alert( 'Please disable your Pop-up blocker and try again.');
    //       // }
    //     }
    //   }
    //   this.messageService.changeMessage("hide-loader-on-editor")
    // }).catch((err: any) => this.messageService.changeMessage("hide-loader-on-editor"))
  }
  downloadQuizPollQuestion(body: any) {
    // return new Promise((resolve, reject) => {
    //   let url = environment.curiosity + '/api/downloads/download-questions';
    //   //  url = 'http://localhost:5001/curiosity-road/us-central1/api/api/downloads/download-questions';
    //   this.http.post<any>(url, body, { responseType: 'blob' as 'json' }).subscribe({
    //     next: data => {
    //       resolve(data)
    //     },
    //     error: error => {
    //       resolve(null)
    //       console.error('There was an error!', error);
    //     }
    //   })
    // })
  }

  sendOtpViaEmail(email:any,quizName:any,){
    return new Promise(async (resolve, reject) => {
      let otp = this.generateOTP();
      const functions = getFunctions(getApp());
      var optSender = httpsCallable(functions, 'otpSender');
      let request: any = {
        mail: email,
        otp: otp,
        quizTitle:quizName //quizTitle means quizName
      };
      let result = await optSender(request)
      if(result){
        resolve({res: true,otpPin: otp})
      }else{
        reject(null)
      }
    });
  }
  generateOTP() {
    // Declare a digits variable
    // which stores all digits
    let digits = '0123456789';
    let OTP = '';
    for (let i = 0; i < 4; i++) {
      OTP += digits[Math.floor(Math.random() * 10)];
    }
    return OTP;
  }

  addWebpageReaderDetails(data:any) {
    return new Promise((resolve, reject) => {
      var info:any = {
        ...data,
        id:this.uuidv4(),
        creationDate:serverTimestamp()
      };
      let docRef = doc(collection(this.firestore,'webPageReaderInfo'),info.id)
      setDoc(docRef,info,{merge:true}).then(result => {
        resolve(true)
      }).catch(err => {
        reject(err)
      })
    })
  }

  getRapidLeagueLeaderBoard(leagueName: any) {
    return new Promise((resolve, reject) => {
      console.log('leagueName : ',leagueName)
      const ref = doc(this.firestore, leagueName, 'Leaderboard')
      getDoc(ref).then(doc => {
        console.log(doc.data())
        if (doc.data()) {
          let tierList: any = null;
          tierList = doc.data();
          resolve(tierList)
        } else {
          resolve(null)
        }
      }).catch(err => {
        console.log(err)
        resolve(null)
      });
    })
  }

}
